import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetChangeRequestsDocument,
  type GetChangeRequestsQuery,
  type GetChangeRequestsQueryVariables,
} from "~/features/changeRequests/gqls";
import type { ChangeRequestListFilters, ChangeRequestSortOrder, SortDirection } from "~/features/changeRequests/types";
import { buildChangeRequestsVariables } from "~/features/changeRequests/utils/transformers";
import { useTenant } from "~/features/tenant/context";

interface UseChangeRequestListArgs {
  filters: ChangeRequestListFilters;
  sortOrder: ChangeRequestSortOrder;
  direction: SortDirection;
  pageIndex: number;
  pageSize: number;
}

/** Server-paginated list of change requests for the current tenant. */
export function useChangeRequestList({ filters, sortOrder, direction, pageIndex, pageSize }: UseChangeRequestListArgs) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetChangeRequestsQuery, GetChangeRequestsQueryVariables>(GetChangeRequestsDocument, {
    variables: buildChangeRequestsVariables({ tenantId, filters, sortOrder, direction, pageIndex, pageSize }),
  });
}
